import type { SearchQueryBody } from "@/types";

export const deviceQueryKeys = {
  all: (orgId: string | undefined) => ["devices", orgId] as const,
  lists: (orgId: string | undefined) =>
    [...deviceQueryKeys.all(orgId), "list"] as const,
  list: (orgId: string | undefined, query: SearchQueryBody) =>
    [...deviceQueryKeys.lists(orgId), query] as const,
};
